import { TV_PANEL_VOCABULARIES } from './tv-panels.js';
/** Slice d647 of the catalog: the vocabularies of the Painel TV links (D647) and the Admin's "Paineis de TV" screen. */
export const SLICE_D647 = [...TV_PANEL_VOCABULARIES];
//# sourceMappingURL=slice-d647.js.map